<template>
    <div>
        <div class="position-relative">
          <!-- shape Hero -->
          <section class="section-shaped my-0">
              <div class="shape shape-style-1 shape-default shape-skew bg-gradient-warning ">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
              </div>
              <div class="container shape-container d-flex">
                  <div class="col px-0">
                      <div class="row">
                          <div class="col-lg-7">
                              <h1 class="display-3 text-white"><span>Welcome to the</span> WeSaidSo Software Engineering <span>site.</span>
                              </h1>
                              <p class="lead  text-white">WeSaidSo Software Engineering is an independent consultancy company, devoted entirely to the architecting and realization of J2EE based solutions.</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
          <!-- 1st Hero Variation -->
        </div>
        <section class="section section-lg pt-lg-0 mt--200">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">Download</h6>
                                    <p class="description mt-3">Etiam risus nisi, molestie ullamcorper nisl venenatis, finibus aliquet nisi.</p>
                                    <div>
                                        <badge type="primary" rounded>design</badge>
                                        <badge type="primary" rounded>system</badge>
                                        <badge type="primary" rounded>creative</badge>
                                    </div>
                                    <base-button tag="a" href="#" type="primary" class="mt-4">
                                        Learn more
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-istanbul" type="success" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-success text-uppercase">Build Something</h6>
                                    <p class="description mt-3">In nisl purus, efficitur hendrerit quam venenatis, mattis placerat lacus</p>
                                    <div>
                                        <badge type="success" rounded>business</badge>
                                        <badge type="success" rounded>vision</badge>
                                        <badge type="success" rounded>success</badge>
                                    </div>
                                    <base-button tag="a" href="#" type="success" class="mt-4">
                                        Learn more
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-planet" type="warning" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-warning text-uppercase">Prepare Launch</h6>
                                    <p class="description mt-3">Fusce nibh dolor, malesuada hendrerit lorem eget, tristique molestie metus.</p>
                                    <div>
                                        <badge type="warning" rounded>marketing</badge>
                                        <badge type="warning" rounded>product</badge>
                                        <badge type="warning" rounded>launch</badge>
                                    </div>
                                    <base-button tag="a" href="#" type="warning" class="mt-4">
                                        Learn more
                                    </base-button>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img src="img/theme/promo-1.png" class="img-fluid floating">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <icon name="ni ni-settings-gear-65" class="mb-5" size="lg" type="success" shadow
                                  rounded></icon>
                            <h3>Awesome features</h3>
                            <p>
                                Fusce nibh dolor, malesuada hendrerit lorem eget, tristique molestie metus. Etiam non velit eu mi imperdiet gravida. Suspendisse ut libero ante. Mauris nec dui elit. Mauris id nisl efficitur, ornare nisl eu, ultricies mi. Quisque nec magna cursus, ornare leo in, porta ligula. Donec sed ipsum pulvinar, finibus mi a, aliquet magna.
                            </p>
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-settings-gear-65"></badge>
                                        <h6 class="mb-0">Nulla vitae nunc felis.</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-html5"></badge>
                                        <h6 class="mb-0">Nulla vitae nunc felis.</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-satisfied"></badge>
                                        <h6 class="mb-0">Nulla vitae nunc felis.</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section bg-secondary">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div class="card bg-default shadow border-0">
                            <img v-lazy="'img/theme/stock-1.jpeg'" class="card-img-top">
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                     class="svg-bg">
                                    <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                    <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">JavaScript Framework</h4>
                                <p class="lead text-italic text-white">Sed nisl orci, sollicitudin quis convallis at, vulputate a tellus.</p>
                            </blockquote>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                            <icon name="ni ni-settings" class="mb-5" size="lg" type="warning" shadow rounded></icon>

                            <h3>Our customers</h3>
                            <p class="lead">Morbi feugiat eros ac lorem vestibulum, ut vulputate erat egestas.</p>
                            <p>Suspendisse in diam blandit, molestie ante sit amet, mollis tortor.</p>
                            <p>Morbi feugiat eros ac lorem vestibulum, ut vulputate erat egestas.</p>
                            <a href="#" class="font-weight-bold text-warning mt-5">Suspendisse in diam blandit, molestie ante sit amet, mollis tortor.</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-warning shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                        <div class="position-relative pl-md-5">
                            <img src="img/ill/ill-2.svg" class="img-center img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <div class="d-flex px-3">
                            <div>
                                <icon name="ni ni-building" size="lg" class="bg-gradient-white" color="primary" shadow
                                      rounded></icon>
                            </div>
                            <div class="pl-4">
                                <h4 class="display-3 text-white">Modern Interface</h4>
                                <p class="text-white">Duis eleifend vitae justo non tincidunt. Donec mi diam, ultrices id tempus quis, blandit id massa.</p>
                            </div>
                        </div>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-satisfied" gradient="success" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-success">Awesome Support</h5>
                                    <p>In nisl purus, efficitur hendrerit quam venenatis, mattis placerat lacus. Aenean ac elit porttitor, fringilla nisi eu, bibendum enim.</p>
                                    <a href="#" class="text-success">Learn more</a>
                                </div>
                            </div>
                        </card>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-active-40" gradient="warning" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-warning">Modular Components</h5>
                                    <p>Nam ut ultrices ex. Sed cursus mi arcu, vitae semper ante pretium lobortis. Nullam aliquet feugiat massa, id accumsan neque.</p>
                                    <a href="#" class="text-warning">Learn more</a>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-8">
                        <h2 class="display-3">The amazing Projects</h2>
                        <p class="lead text-muted">Sed nisl orci, sollicitudin quis convallis at, vulputate a tellus. Cras eu fringilla nisi.</p>
                    </div>
                </div>

                <div v-for="projectGroup in groupedProjects" v-bind:key="projectGroup.id"
                    class="row row-grid">
                    <div v-for="project in projectGroup" v-bind:key="project.id"
                        class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="project.src"
                                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span v-if="project.title" class="d-block mb-1">{{ project.title }}</span>
                                    <small v-if="project.role" class="h6 text-muted">{{ project.role }}</small>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="#" type="warning" icon="fa fa-linkedin" rounded
                                        icon-only></base-button>
                                    <base-button tag="a" href="#" type="warning" icon="fa fa-globe" rounded
                                        icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg pt-0">
            <div class="container">
                <card gradient="warning"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-center">
                            <div class="col-lg-8">
                                <h3 class="text-white">Workshop Java EE Programming.</h3>
                                <p class="lead text-white mt-3">Aenean ultricies hendrerit sem a finibus. Vestibulum a nisi id quam hendrerit hendrerit. Duis eleifend vitae justo non tincidunt.</p>
                            </div>
                            <div class="col-lg-3 ml-lg-auto">
                                <base-button tag="a" href="#"
                                    type="white" block size="lg">
                                    Contribute now
                                </base-button>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg pb-300">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Build something</h2>
                        <p class="lead text-white">Suspendisse in sagittis odio. Vivamus tempor, ligula eget cursus posuere, diam nulla facilisis mauris, at vulputate leo augue a urna. Lorem ipsum dolor sit ligula eget cursus posuere amet, consectetur adipiscing elit.</p>
                    </div>
                </div>
                <div class="row row-grid mt-5">
                    <div class="col-lg-4">
                        <icon name="ni ni-settings" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Building tools</h5>
                        <p class="text-white mt-3">Etiam faucibus maximus interdum. Morbi fringilla leo ac quam facilisis lobortis.</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="ni ni-ruler-pencil" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Grow your market</h5>
                        <p class="text-white mt-3">Sed nisl orci, sollicitudin quis convallis at, vulputate a tellus.</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="ni ni-atom" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Launch time</h5>
                        <p class="text-white mt-3">Cras eu fringilla nisi. Vivamus condimentum faucibus ante eget accumsan.</p>
                    </div>
                </div>
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <p class="lead text-white">
                            The WeSaidSo software engineers take a no-nonsense approach, communicate clearly and to-the-point, and give preference to working in small teams (3 a 4 persons) so as to best enable knowlegde transfer.
                            They use a mix of eXtreme Programming (XP) techniques, principles from the Rational Unified Process (RUP) and Design Patterns to reach the desired goal in speedy, repeatable, structured manner...
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg pt-lg-0 section-contact-us">
            <div class="container">
                <div class="row justify-content-center mt--300">
                    <div class="col-lg-8">
                        <card gradient="secondary" shadow body-classes="p-lg-5">
                            <h4 class="mb-1">Want to work with us?</h4>
                            <p class="mt-0">Your project is very important to us.</p>
                            <p>{{ $t('hello') }}</p>                            
                            
                            <form accept-charset="UTF-8" action="https://usebasin.com/f/87407d9533ff" method="POST" ref="form">
                              <!-- Form alternative -->
                              <!-- <label for="email-address">Email Address</label>
                              <input type="email" id="email" name="email" required>
                              <textarea class="textarea is-large" name="message" rows="5" required></textarea>
                              <button type="submit">Submit</button> -->
                              <base-input class="mt-5"
                                          alternative
                                          placeholder="Your name"
                                          addon-left-icon="ni ni-user-run"
                                          v-model="form.name">
                              </base-input>
                              <base-input v-model="form.email"
                                          placeholder="Email address"
                                          addon-left-icon="ni ni-email-83"
                                          alternative
                                          required>
                              </base-input>
                              <base-input class="mb-4">
                                      <textarea v-model="form.text" class="form-control form-control-alternative" name="name" rows="4"
                                                cols="80" placeholder="Type a message..."></textarea>
                              </base-input>
                              <base-button v-on:click="submit" type="default" round block size="lg">
                                  Send Message
                              </base-button>
                            </form>
                        </card>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid justify-content-center">
                    <div class="col-lg-8 text-center">
                      <!-- Remove this section -->
                        <h2 class="display-3">Do you love this awesome
                            <span class="text-warning">design and website?</span>
                        </h2>
                        <p class="lead">Cause if you do, it can be yours for small charge. Hit the button below to navigate to
                            IP Consultancy you can find the contact details in there. Start a new project or give an
                            old Bootstrap project a new look!</p>
                        <div class="btn-wrapper">
                            <a href="https://ivopauly.com/contact"
                               class="btn btn-primary mb-3 mb-sm-0">Confirm the assignment</a>
                        </div>
                        <div class="text-center">
                            <h4 class="display-4 mb-5 mt-5">Specialized in these technologies</h4>
                            <div class="row justify-content-center">
                                <div class="col-lg-2 col-4">
                                    <a href="#" target="_blank" data-toggle="tooltip"
                                       data-original-title="Vue.js - The progressive javascript framework">
                                        <img v-lazy="'img/icons/vue.jpg'"
                                             class="img-fluid">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a href="#" target="_blank" data-toggle="tooltip"
                                       data-original-title="Vue.js - The progressive javascript framework">
                                        <img v-lazy="'img/icons/vue.jpg'"
                                             class="img-fluid">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a href="#" target="_blank" data-toggle="tooltip"
                                       data-original-title="Vue.js - The progressive javascript framework">
                                        <img v-lazy="'img/icons/vue.jpg'"
                                             class="img-fluid">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a href="#" target="_blank" data-toggle="tooltip"
                                       data-original-title="Vue.js - The progressive javascript framework">
                                        <img v-lazy="'img/icons/vue.jpg'"
                                             class="img-fluid">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a href="#" target="_blank" data-toggle="tooltip"
                                       data-original-title="Vue.js - The progressive javascript framework">
                                        <img v-lazy="'img/icons/vue.jpg'"
                                             class="img-fluid">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: "home",
  components: {},
  data() {
    return {
      projects: [
        { id: 1, title: 'KPN', role: 'Developer', description: this.$t('projects.kpn.description'), src:'img/projects/kpn.png', url: '#' },
        { id: 2, title: 'KVK', role: 'Developer', description:this.$t('projects.kvk.description'), src:'img/projects/kvk.png', url: '#' },
        { id: 3, title: 'Van Meijel', role: 'Developer', description:this.$t('projects.vanmeijel.description'), src:'img/projects/van-meijel.png', url: '#' },
        { id: 4, title: 'Van Meijel', role: 'Developer', description:this.$t('projects.vanmeijel.description'), src:'img/projects/servicehouse.png', url: '#' }
      ],
      form: {
        name: '',
        email: '',
        text: ''
      }
    }
  },
  computed: {
    groupedProjects() {
      let grouped = [];
      let index = -1;
      for (let i = 0; i < this.projects.length; i++) {
        if (i % 4 == 0) { 
          index++;
          grouped[index] = [];
        }
        grouped[index].push(this.projects[i]);
      }
      return grouped;
  }
  },
  methods: {
    submit: function() {
      this.$refs.form.submit();
    }
  }
};
</script>

<i18n>
{
  "en": {
    "hello": "Hello i18n in SFC English!"
  },
  "nl": {
    "hello": "Hello i18n in SFC Nederlands!"
  }
}
</i18n>